import {IComponentOptions} from 'angular';
declare let require: any;
declare let angular: any;
let template = require('./dv-input-container.html');
require('./dv-input-container.scss');

export class DvInputContainerComponentConfig implements IComponentOptions {
    transclude = true;
    template = template;
    controller = DvInputContainerController;
    controllerAs = 'vm';

}

export class DvInputContainerController {

    static $inject: any[] = [];
    /* @ngInject */
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-input-container/dv-input-container.ts